import React from "react";
import { Dialog, DialogContent, DialogActions, Button, Grid, TextField, DialogTitle, Divider, } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { submitReopenCase, submitCloneCase } from "../../../../redux/actions";
import { useFormState } from "../../../../hooks/useFormState";
const MULTILINE_ROW_HEIGHT = 8;
export const ReopenCaseDialog = ({ isDialogOpen, onDialogClose, caseId, }) => {
    const dispatch = useDispatch();
    const { formProps, triggerSubmit, triggerReset, state } = useFormState({
        noteBody: "",
    }, ["noteBody"], ({ state }) => {
        dispatch(state.values.isCloneSubmit
            ? submitCloneCase(caseId, Object.assign({}, state.values))
            : submitReopenCase(caseId, Object.assign({}, state.values)));
        onDialogClose();
        triggerReset();
    });
    return (React.createElement(Dialog, { open: isDialogOpen, onClose: () => {
            onDialogClose();
            triggerReset();
        }, maxWidth: "md", fullWidth: true },
        React.createElement(DialogTitle, null, "Reopen Case"),
        React.createElement(Divider, null),
        React.createElement(DialogContent, null,
            React.createElement("form", null,
                React.createElement(Grid, { container: true, spacing: 3 },
                    React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                        React.createElement(TextField, Object.assign({ variant: "outlined" }, formProps("noteBody"), { label: "Note", "data-test": "reopen-case-note", fullWidth: true, multiline: true, rows: MULTILINE_ROW_HEIGHT })))))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: () => {
                    state.values.isCloneSubmit = true;
                    triggerSubmit();
                }, "data-test": "dialog-ok-clone", color: "primary" }, "Clone case"),
            "\u00A0",
            React.createElement(Button, { onClick: () => triggerSubmit(), "data-test": "reopen-case-confirm", color: "primary" }, "Reopen case"))));
};
